import { globalCommands, richTextEditorCommands } from 'app/app.commands';
import { searchCommands } from 'app/views/layout/views/search/search.commands';
import { conversationCopilotDropdownCommands } from 'components/conversation/conversationCopilotDropdown';
import { editorCopilotDropdownCommands } from 'components/editorCopilotDropdown';

import { conversationCommands } from '../../../assets/components/conversation/utils/conversation.commands';
import { Command, CommandGroup } from '../types/command.types';

/** Represents the available strongly typed commands. */
export const commandDefinitions = [
  ...conversationCommands,
  ...conversationCopilotDropdownCommands,
  ...globalCommands,
  ...searchCommands,
  ...richTextEditorCommands,
  ...editorCopilotDropdownCommands,
];

/** Represents the available commands. */
export const commands = commandDefinitions as readonly Command[];

/** Represents the available internal commands. */
export const commandsInternal = commands.filter(
  (command) => !command.isExternal,
) as readonly Command[];

/** Represents the available commands keybindings of which can be rebound. */
export const commandsKeyboardRebindable = commands.filter(
  (command) => !(command.keyboard && !!command.keyboard.isNonRebindable),
) as readonly Command<CommandGroup>[];
